import React, { useState, useCallback, useEffect, useMemo } from "react";
import CloudUploadIcon from "@material-ui/icons/CloudUpload";
import { useDropzone } from "react-dropzone";
import { withTranslation } from "react-i18next";
import Grid from "@material-ui/core/Grid";
import AuthService from "../session/AuthService";
import i18n from "../i18n";

const baseStyle = {
  display: "flex",
  flexDirection: "column",
  alignItems: "center",
  padding: "20px",
  borderWidth: 2,
  borderRadius: 2,
  borderColor: "#A00030",
  borderStyle: "dashed",
  backgroundColor: "#fafafa",
  color: "#A00030",
  transition: "border .3s ease-in-out",
  cursor: "pointer",
};

const activeStyle = {
  borderColor: "#2196f3",
};

const acceptStyle = {
  borderColor: "#00e676",
};

const rejectStyle = {
  borderColor: "#ff1744",
};

const Dropzone = (props) => {
  const [uploadedImage, setImage] = useState(null);
  const [name, setName] = useState("");

  const onDrop = useCallback((acceptedFiles) => {
    if (acceptedFiles && acceptedFiles.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImage(reader.result));
      reader.readAsDataURL(acceptedFiles[0]);
      setName(acceptedFiles[0].name);
      props.onUploadSuccess(acceptedFiles[0]); // Pass the uploaded file to the parent component
    }
  }, []);

  const backtochooseimage = () => {
    setImage(null);
    setName("");
  };

  const onSelectFile = (e) => {
    if (e.target.files && e.target.files.length > 0) {
      const reader = new FileReader();
      reader.addEventListener("load", () => setImage(reader.result));
      reader.readAsDataURL(e.target.files[0]);
      setName(e.target.files[0].name);
      props.onUploadSuccess(e.target.files[0]); // Pass the uploaded file to the parent component
    }
  };

  useEffect(() => {
    let langValue = AuthService.getCommonLanguages();
    i18n.changeLanguage(langValue);
  }, []);

  const {
    getRootProps,
    getInputProps,
    isDragActive,
    isDragAccept,
    isDragReject,
  } = useDropzone({
    onDrop,
    accept: "image/jpeg, image/png",
    multiple: false,
    maxSize: 31457280,
  });

  const style = useMemo(
    () => ({
      ...baseStyle,
      ...(isDragActive ? activeStyle : {}),
      ...(isDragAccept ? acceptStyle : {}),
      ...(isDragReject ? rejectStyle : {}),
    }),
    [isDragActive, isDragReject, isDragAccept]
  );

  return (
    <div>
      {!uploadedImage && (
        <div
          {...getRootProps({ style })}
          className="card page-background text-center file-uploader"
        >
          <input {...getInputProps()} onChange={(e) => onSelectFile(e)} />
          <div className="upload-icon">
            <CloudUploadIcon fontSize="inherit" />
          </div>
          <div className="text-large-weighted mb-3">
            {props.t("Drag and drop a file here or click to select a file")}

            <p>
              {props.t(
                "Choose file below 30 mb else it will be auto removed from the list"
              )}
            </p>
          </div>
        </div>
      )}

      {uploadedImage && (
        <>
          <div
            style={{
              width: "100%",
              display: "flex",
              justifyContent: "center",
              marginTop: "20px",
              
            }}
          >
            <img
              src={uploadedImage}
              alt="Uploaded"
              style={{ maxWidth: "100%", maxHeight: "300px" }}
            />
          </div>
          <Grid container spacing={1} alignItems="center" wrap="nowrap">
         
              <button
                style={{ marginTop: "12px", marginBottom: "12px"}}
                onClick={backtochooseimage}
              >
                {props.t("Back")}
              </button>
           
          </Grid>
        </>
      )}
    </div>
  );
};

export default withTranslation()(Dropzone);